'use strict';
(function () {
  const button = document.getElementById('ham');
  const menu = document.getElementById('gnav');
  const main = document.querySelector('main');
  const footer = document.querySelector('footer');
  function setMenu(open, restoreFocus = false) {
    document.body.classList.toggle('nav_open', open);
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    menu.inert = !open;
    main.inert = open;
    footer.inert = open;
    if (open) menu.querySelector('a').focus();
    else if (restoreFocus) button.focus();
  }
  setMenu(false);
  button.addEventListener('click', () => setMenu(button.getAttribute('aria-expanded') !== 'true'));
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false, true)));
  document.addEventListener('keydown', event => {
    if (button.getAttribute('aria-expanded') !== 'true') return;
    if (event.key === 'Escape') setMenu(false, true);
    if (event.key !== 'Tab') return;
    const targets = [...document.querySelectorAll('header.general a, header.general button')]
      .filter(element => element.getClientRects().length && !element.closest('[inert]'));
    const first = targets[0];
    const last = targets[targets.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  // The answers remain visible without JavaScript. Enhance them to native disclosures.
  document.querySelectorAll('.faq .block').forEach(block => {
    const question = block.querySelector('.q_area');
    const answer = block.querySelector('.a_area');
    if (!question || !answer) return;
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    summary.className = question.className;
    while (question.firstChild) summary.append(question.firstChild);
    details.append(summary, answer);
    block.replaceChildren(details);
  });

  const sourceMap = {
    ig: { source: 'instagram', rid: 7 },
    tiktok: { source: 'tiktok', rid: 27 },
    threads: { source: 'threads', rid: 18 },
    x: { source: 'x', rid: 15 },
    pinterest: { source: 'pinterest', rid: 19 },
    substack: { source: 'substack', rid: 17 },
    note: { source: 'note', rid: 16 },
    yt: { source: 'youtube', rid: 20 },
    ig_story: { source: 'instagram', rid: 23 }
  };
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

  function getAttribution() {
    const params = new URLSearchParams(location.search);
    let src = params.get('src');
    try {
      if (src && sourceMap[src]) sessionStorage.setItem('gk_lp_src', src);
      else src = sessionStorage.getItem('gk_lp_src');
    } catch (_) {}
    if (!sourceMap[src]) src = '';

    const values = {};
    attributionKeys.forEach(key => {
      let value = params.get(key);
      try {
        if (value) sessionStorage.setItem(`gk_lp_${key}`, value);
        else value = sessionStorage.getItem(`gk_lp_${key}`);
      } catch (_) {}
      if (value) values[key] = value;
    });
    if (src && !values.utm_source) values.utm_source = sourceMap[src].source;
    return { src, ...values };
  }

  const attribution = getAttribution();
  const lineRid = attribution.src ? sourceMap[attribution.src].rid : 11;

  // lin.ee drops arbitrary query parameters. Use the verified ChatBoost LIFF route instead.
  document.querySelectorAll('a[href*="lin.ee/"], a[href*="liff.line.me/"], a[href*="line.me/R/app/"]').forEach(link => {
    link.href = `https://line.me/R/app/2007178760-W2oQLzjq?rid=${lineRid}`;
  });

  // Carry the original SNS attribution across the external Locaop booking domain.
  document.querySelectorAll('a[href*="res.locaop.jp/"]').forEach(link => {
    const url = new URL(link.href, location.href);
    if (attribution.utm_source) {
      attributionKeys.forEach(key => {
        if (attribution[key]) url.searchParams.set(key, attribution[key]);
      });
      if (attribution.src) url.searchParams.set('src', attribution.src);
    }
    link.href = url.href;
  });

  function publishEvent(name, parameters) {
    const payload = {
      lp_id: 'kampo_soudan',
      traffic_source: attribution.utm_source || 'direct',
      traffic_medium: attribution.utm_medium || '(none)',
      traffic_campaign: attribution.utm_campaign || '(not set)',
      ...parameters
    };
    window.dataLayer = window.dataLayer || [];
    // The current isolated Shopify layout loads GA4 directly. If it is later
    // migrated to GTM, the same function falls back to a custom dataLayer event.
    if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    else window.dataLayer.push({ event: name, ...payload });
  }

  publishEvent('lp_view', { page_type: 'sns_profile_lp' });

  // Publish only coarse interaction events; no symptom, message, patient data or PDF titles.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    let type;
    if (url.hostname === 'lin.ee' || url.hostname === 'liff.line.me'
      || (url.hostname === 'line.me' && url.pathname.startsWith('/R/app/'))) type = 'line';
    else if (url.hostname === 'res.locaop.jp') type = 'booking';
    else if (url.protocol === 'tel:') type = 'phone';
    else if (url.hostname === 'drive.google.com') type = 'pdf';
    if (!type) return;
    const section = link.closest('section');
    const position = link.closest('.fix_nvs') ? 'fixed' : link.closest('header.general') ? 'header'
      : section?.classList.contains('fv') ? 'hero' : section?.id || 'cta';
    const common = { cta_type: type, cta_position: position };
    publishEvent('lp_cta_click', common);
    if (type === 'line') publishEvent('line_add_click', { ...common, line_rid: String(lineRid) });
    else if (type === 'booking') publishEvent('booking_start', common);
    else if (type === 'phone') publishEvent('phone_click', common);
    else if (type === 'pdf') publishEvent('pdf_click', common);
    // Actual LINE additions are counted in ChatBoost by line_rid. A completed
    // booking is counted as reserve_complete on Locaop's /thanks page.
  });
})();
